<script>
    export let style = 'Primary';
    export let size = '';
    export let width = 'w-full';
    export let vibrate = 0;
    export let onclick = undefined;

    // Link Props
    export let href = '';
    export let target = '';
    export let title = '';

    // Button Props
    export let disabled = false;
    export let type = 'button';

    // Set Small Size Classes
    const height = size === 'Small' ? 'h-9' : 'h-12';
    const textSize = size === 'Small' ? 'text-sm' : 'text-base';

    // Set Disbaled Button Classes
    const disabledStyles = href ? '' : 'disabled:bg-base-700 disabled:bg-none disabled:text-color-text/30';

    // Set Button Style
    let buttonStyle = '';
    switch (style) {
        case 'Featured':
            buttonStyle = `featured relative flex ${height} ${width} flex-col justify-center items-center rounded-xl bg-primary px-3.5 text-center text-[0.875rem] font-medium uppercase tracking-[0.9px] text-white ${disabledStyles}`;
            break;
        case 'Primary':
            buttonStyle = `relative flex ${height} ${width} flex-col justify-center items-center rounded-xl bg-primary px-3.5 text-center ${textSize} font-semibold text-white ${disabledStyles}`;
            break;
        case 'Secondary':
            buttonStyle = `relative flex ${height} ${width} flex-col justify-center items-center rounded-xl bg-black/80 px-3.5 text-center ${textSize} font-semibold text-white dark:bg-base-700 ${disabledStyles}`;
            break;
        default:
            buttonStyle = ``;
            break;
    }

    // Set haptic feedback length for btn if available
    const hapticVibrate = () => {
        if (vibrate > 0 && navigator && 'vibrate' in navigator) {
            navigator.vibrate(vibrate);
            return;
        }
        return false;
    };
</script>

{#if href}
    <a {href} class={buttonStyle} on:click={hapticVibrate} on:click={onclick} {title} {target}>
        <slot />
    </a>
{:else}
    <button {type} class={buttonStyle} on:click={hapticVibrate} on:click={onclick} {disabled}>
        <slot />
    </button>
{/if}

{#if !disabled}
    <style>
        .featured {
            background: linear-gradient(to right, #2d45ee -57%, #6f1fff 55%, #034dff 122%);
            -webkit-transition-duration: 0.4s;
            transition-duration: 0.4s;
        }
        .featured:after {
            content: '';
            display: block;
            position: absolute;
            border-radius: 1rem;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            opacity: 0;
            transition: all 0.5s;
            box-shadow: 0 0 5px 20px #6f1fff;
        }
        .featured:active:after {
            box-shadow: 0 0 0 0 #6f1fff;
            position: absolute;
            border-radius: 1rem;
            left: 0;
            top: 0;
            opacity: 1;
            transition: 0s;
        }
    </style>
{/if}
